import Swal from "sweetalert2";

export function successToast(titulo) {
    const title = titulo;
    const Toast = Swal.mixin({
        toast: true,
        position: "bottom-end",
        background:"#1aa310",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: false,
        showCloseButton:true,
        didOpen: (toast) => {
          toast.onmouseenter = Swal.stopTimer;
          toast.onmouseleave = Swal.resumeTimer;
        }
    });
    const alert = Toast.fire({
        icon: "success",
        iconColor:"#FFFFFF",
        color:"#FFFFFF",
        title: title.toUpperCase()
    });
    return alert;
}

export function errorToast(Title, Message) {
    const title = Title;
    const message = Message === undefined ? '': Message;
    const Toast = Swal.mixin({
        toast: true,
        position: "bottom-end",
        background:"#f50400",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: false,
        showCloseButton:true,
        didOpen: (toast) => {
          toast.onmouseenter = Swal.stopTimer;
          toast.onmouseleave = Swal.resumeTimer;
        }
    });
    const alert = Toast.fire({
        icon: "error",
        iconColor:"#FFFFFF",
        color:"#FFFFFF",
        title: title.toUpperCase(),
        text: message.toUpperCase(),
    });
    return alert;
}

export function errorMessage(msg) {
    const message = msg;
    const alert =  Swal.fire(
        'Error...',
        message,
        'question'
    );
    return alert;
}

export function warningToast(Title,Text,ShowCancel) {
    const title = Title;
    const text = Text === undefined ? '' : Text;
    const show = ShowCancel === undefined ? false : ShowCancel;
    const alert = Swal.fire({
        title: title.toUpperCase(),
        text: text.toUpperCase(),
        icon: 'warning',
        iconColor:'#1A2E4F',
        confirmButtonColor: '#1A2E4F',
        confirmButtonText: 'ACEPTAR',
        showCancelButton: show,
        cancelButtonColor: '#d33',
        cancelButtonText: 'CANCELAR',
        timer: show === true ? undefined : 5000,
        toast:true,
        background:'#f5f5f5',
        customClass:{
            popup: "border-sweetA"
        },
    });
    return alert;
}

export function warningModal(Title,Text) {
    const title = Title
    const text = Text === undefined ? '': Text;
    const alert = Swal.fire({
        title: title.toUpperCase(),
        text: text.toUpperCase(),
        icon: 'warning',
        iconColor:'#1A2E4F',
        color: '#1A2E4F',
        confirmButtonColor: '#1A2E4F',
        confirmButtonText: 'ACEPTAR',
        showCancelButton: true,
        cancelButtonColor: '#d33',
        cancelButtonText: 'CANCELAR',
        customClass:{
            popup: "border-sweetA"
        }
    });
    return alert;
}

export function closeAlert() {
    const close = Swal.close();
    return close;
}